import Image from './AvatarImage';
import Icon from './AvatarIcon';
import Text from './AvatarText';

export default {
  Image,
  Icon,
  Text,
};
